// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jf-0";
export var discountCodeInput = "_jf-1";